import * as React from "react";

import LS03, { LS03Props } from "@stadium/shared/src/components/plasmic/LS03";

import { LogoStripsVariant, L_03 } from "@stadium/shared/src/helpers/plasmic/static-slices";

export interface LS03LogoStripsProps {
  logoStripEyebrow?: LS03Props["logoStripEyebrow"];
  logoStripHeading?: LS03Props["logoStripHeading"];
  companyLogo1?: LS03Props["companyLogo1"];
  companyLogo2?: LS03Props["companyLogo2"];
  companyLogo3?: LS03Props["companyLogo3"];
  companyLogo4?: LS03Props["companyLogo4"];
  companyLogo5?: LS03Props["companyLogo5"];
  companyLogo6?: LS03Props["companyLogo6"];
}

export interface LogoStripsProps extends LS03LogoStripsProps {
  variant?: LogoStripsVariant;
  backgroundColor?: string;
  className?: string;
}

const LogoStrips: React.FC<Readonly<LogoStripsProps>> = (props) => {
  const { variant = L_03 } = props;

  if (variant === L_03) {
    const {
      logoStripEyebrow,
      logoStripHeading,
      companyLogo1,
      companyLogo2,
      companyLogo3,
      companyLogo4,
      companyLogo5,
      companyLogo6,
      backgroundColor,
      className,
    } = props;

    return (
      <LS03
        logoStripEyebrow={logoStripEyebrow}
        logoStripHeading={logoStripHeading}
        companyLogo1={companyLogo1}
        companyLogo2={companyLogo2}
        companyLogo3={companyLogo3}
        companyLogo4={companyLogo4}
        companyLogo5={companyLogo5}
        companyLogo6={companyLogo6}
        backgroundColor={backgroundColor}
        className={className}
      />
    );
  }

  return null;
};

export default LogoStrips;
